import http from "../../shared/http";

const events = {
    state: {
        events: []
    },
    actions: {
        fetchEvents({commit}) {
            if (this.state.events.events.length > 0) {
                return
            }

            return new Promise((resolve, reject) => {
                http.get("/v1system/events", {
                    headers: {
                        'X-Project-Uuid': localStorage.getItem("current_project_uuid")
                    }
                })
                .then((resp) => {
                    commit('SET_EVENTS', resp.data || []);
                    resolve();
                }).catch((err) => {
                    reject();
                })
            })
        }
    },
    mutations: {
        SET_EVENTS (state, events) {
            state.events.concat(events)
        },

        SET_EVENT (state, event) {
            state.events.push(event)
        },
    },
    getters: {
        event: (state) => (uuid) => {
            return state.events.find((e) => {
                return e.uuid == uuid;
            })

        },

        eventList(state) {
            return state.events;
        }
    }
  }

export default events;